export default {
	'add-message': 'إضافة رسالة',
	'edit-message': 'تعديل رسالة',
}